import axios, { encodeData } from "../utils/axios";

export const fetchshipconfigService = async (id) => {
  const res = await axios
    .get("/shipconfig/", {
      params: {
        id,
      },
    })
    .catch((error) => {
      if (error.response) {
        console.error(error);
      }
    });

  return res.data;
};

export const createShipconfigService = async (newShipConfigService) => {
  await axios.post("/shipconfig/create", encodeData(newShipConfigService));
};

export const updateShipconfigService = async (updateShipConfigService) => {
  await axios.put("/shipconfig/update", encodeData(updateShipConfigService));
};

export const deleteShipconfigService = async (deleteShipConfigService) => {
  await axios.delete("/shipconfig/delete", {
    data: encodeData(deleteShipConfigService),
  });
};
